/* eslint-disable import/no-anonymous-default-export */

import { GET_TASK_DETAIL, SET_LIST_DATA, SET_LIST_LOADING } from "../actions/Common.action";

const initialState = {
  present: [],
  lists: {
    PRODUCTS: [],
  },
  isLoading: false,
};

export default function (
  state = JSON.parse(JSON.stringify(initialState)),
  action
) {
  switch (action.type) {
    case GET_TASK_DETAIL: {
      const newData = action.payload;
      return {
        ...state,
        present: newData,
      };
    }
    case SET_LIST_DATA: {
      return {
        ...state,
        lists: {
          ...state.lists,
          ...action.payload,
        },
      };
    }
    case SET_LIST_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
